import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';

const TrainingManagementTopNav = () => {
  return(
    <div className="topbar -admin-subnav">
      <div>
        <ul className="navigation -left">
          <li><small><em>Content Management:</em></small></li>
          <li className="-pipe"/>
          <li><NavLink to="/admin/content-management/studies" activeClassName="active">Programs</NavLink></li>
          <li><NavLink to="/admin/content-management/courses" activeClassName="active">Courses</NavLink></li>
          <li className="-pipe"/>
        </ul>
      </div>
    </div>
  )
}

export default withRouter(TrainingManagementTopNav);



// WEBPACK FOOTER //
// modules/admin/components/TrainingManagementTopNav.js.jsx